import { Link, useLocation } from "react-router-dom";

export default function SiteFooter() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;
  return (
    <footer className="bg-[#0B132B] text-slate-200 mt-24" data-testid="site-footer">
      <div className="tw-container py-14 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="tw-overline !text-[#00E5FF]">TW Calc</div>
          <h3 className="mt-3 text-3xl font-extrabold text-white leading-tight">
            Estimate, compare,<br/>and save your quote.
          </h3>
          <p className="mt-4 text-sm text-slate-400 max-w-md">
            Unofficial calculator and promo browser for Total Wireless plans and devices.
          </p>
        </div>
        <div className="md:col-span-3">
          <div className="tw-overline !text-slate-400">Tools</div>
          <ul className="mt-3 space-y-2 text-sm">
            <li><Link to="/estimator" className="hover:text-[#00E5FF]">Bill Estimator</Link></li>
            <li><Link to="/devices" className="hover:text-[#00E5FF]">Device Catalog</Link></li>
            <li><Link to="/admin" className="hover:text-[#00E5FF]">Admin</Link></li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <div className="tw-overline !text-slate-400">Legal</div>
          <p className="mt-3 text-xs text-slate-500 leading-relaxed">
            Not affiliated with or endorsed by Total Wireless, TracFone, or Verizon.
            Pricing displayed is informational; final pricing may include taxes,
            fees and surcharges that vary by location.
          </p>
        </div>
      </div>
      <div className="border-t border-slate-800">
        <div className="tw-container py-5 flex flex-col md:flex-row items-start md:items-center justify-between gap-2 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} TW Calc — Created by the Association of Master Agents for Verizon Value</div>
          <div className="mono">v1.0</div>
        </div>
      </div>
    </footer>
  );
}
